import { AppData, Step } from "../../AppDataProvider";
import {
  ResourceAllocationType,
  ResourceSelectionMode,
} from "../../../GeneratedGraphQL";
import { CompleteServicesStepPayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel";

export type CompleteServicesStepOpts = {
  appData: AppData;
  payload: CompleteServicesStepPayload;
};

export const completeServicesStep = (
  options: CompleteServicesStepOpts,
): AppData => {
  const { bookingTool, bookingData } = options.appData;
  const { service } = options.payload.updatedData;

  Mixpanel.track({
    name: "Completed step",
    props: {
      selectedService: { id: service._id, name: service.name },
      step: "services",
    },
  });

  const resourceSelectionBeforeAvailability =
    bookingData.organisation?.resourceSelectionBeforeAvailability;

  const { resourceSelectionMode } = bookingTool;

  const getNextStep = (): Step => {
    /**
     * If we have been provided a resourceId in the url params,
     * we want to navigate to the resources step where the
     * provided resource will be automatically selected
     */
    const urlParams = new URLSearchParams(window.location.search);
    const preFillResourceId = urlParams.get("resourceId");

    if (service.tiers && service.tiers.length > 0) {
      return "multiTier";
    }

    if (
      resourceSelectionBeforeAvailability &&
      service.resourceAllocationType === ResourceAllocationType.Any &&
      (resourceSelectionMode !== ResourceSelectionMode.Disabled ||
        preFillResourceId)
    ) {
      return "resources";
    }
    return "availability";
  };

  // If the selected service has only one duration or only allows one attendee,
  // we also need to set those values in the bookingData
  const { durations, maxParticipantsPerBooking } = service;

  const updatedBookingData = {
    ...bookingData,
    ...options.payload.updatedData,
    ...(durations.length === 1 && { duration: durations[0] }),
    ...((maxParticipantsPerBooking ?? 1) === 1 && { attendees: 1 }),
  };

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: getNextStep(),
  };
};
